import { ENABLE_V3_SEARCH_ON_DISCOVER_PAGE_240731 } from "@faire/web-api/indigofair/settings/ENABLE_V3_SEARCH_ON_DISCOVER_PAGE_240731";

import {
  assignSetting,
  getSettingValueWithoutAssignment,
} from "@faire/retailer/settings/__internal__/getSetting";

export const assignEnableV3SearchWithLoggedOutDiscover = () => {
  assignSetting(ENABLE_V3_SEARCH_ON_DISCOVER_PAGE_240731);
};

export const getSettingEnableV3SearchWithLoggedOutDiscover = (): boolean =>
  getSettingValueWithoutAssignment(
    ENABLE_V3_SEARCH_ON_DISCOVER_PAGE_240731,
    false
  );
